import * as oidc from 'oidc-client-ts';
import { useCallback, useEffect, useRef } from 'react';
import { oidcStores } from '~/lib/oidc-storage';

export default function Component() {
  // StrictMode runs this effect twice in dev; notifying the parent frame once is enough.
  const started = useRef(false);

  const load = useCallback(() => {
    window.location.hash = decodeURIComponent(window.location.hash);

    const mgr = new oidc.UserManager({
      authority: `https://parcel2go.test.p2g.ninja/auth`,
      client_id: 'smartsend.cs',
      loadUserInfo: true,
      redirect_uri: '',
      ...oidcStores()
    });

    mgr.signinSilentCallback().catch((error) => {
      console.error(error);
    });
  }, []);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    load();
  }, [load]);

  return <>Loading...</>;
}

Component.displayName = 'Silent';
